import { useState } from 'react';

const FAQ_ITEMS = [
  {
    q: '每日爆料大赛是什么？如何参与？',
    a: '每日爆料大赛是每日爆料平台的核心赛事，用户可以通过投稿真实爆料内容参与比赛。每一条通过审核的爆料作品会自动进入当日排名，根据热度、讨论度、可信度等多维度进行综合评分。参与方式非常简单：点击页面上的"我要爆料"按钮，按指引提交你的爆料内容即可。',
  },
  {
    q: '爆料内容的真实性如何保证？',
    a: '我们采用"社区交叉验证 + 编辑人工审核"双重机制。每条爆料发布后会开放社区讨论，其他用户可以补充证据或提出质疑。编辑团队会持续跟踪事件进展，对已证实的爆料标注"实锤"标签，对存疑内容标注"待核实"，对虚假内容会即时下架并公示。',
  },
  {
    q: '爆料大赛的排名规则是怎样的？',
    a: '排名综合考量四个维度：热度值（阅读与分享）、讨论度（评论数与质量）、可信度（证据完整性与交叉验证结果）以及时效性（发布时间）。系统每小时自动刷新排名，每日零点重置日榜，每周一生成周榜，每月初生成月榜，并在首页爆料热榜区域实时展示。',
  },
  {
    q: '投稿爆料有奖励吗？',
    a: '当然有！每日日榜前三名可获得平台流量推荐位；周榜前十名获得「爆料达人」认证标识；月榜冠军更可获得现金奖励与年度爆料盛典入围资格。此外，持续产出高质量爆料的用户还有机会成为平台签约爆料人，享受固定稿酬与专属资源支持。',
  },
  {
    q: '如何保护爆料人的隐私安全？',
    a: '我们高度重视爆料人的隐私保护。投稿时默认采用匿名发布模式，所有涉及个人身份的信息在审核阶段就会被移除或脱敏处理。平台采用端到端加密技术保护上传文件，且不会向任何第三方透露爆料人的注册信息或联系方式。你只管爆料，安全交给我们。',
  },
  {
    q: '发现不实信息或侵权内容怎么办？',
    a: '每条爆料内容下方均设有"举报"按钮，点击后选择举报类型并提交说明即可。我们的审核团队会在2小时内处理举报，对于核实的不实信息会立即标注并下架，对侵权内容会在24小时内完成处理。同时，被爆料方也可以通过官方邮箱提交澄清材料，我们会以"当事方回应"形式同步展示。',
  },
];

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">常见问题</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">
          关于每日爆料大赛，你想知道的都在这里
        </p>

        <div className="max-w-3xl mx-auto space-y-3">
          {FAQ_ITEMS.map((item, i) => (
            <div
              key={i}
              className="bg-background-100 rounded-xl border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between p-5 text-left cursor-pointer"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {item.q}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-all ${
                  openIndex === i ? 'bg-primary-500 text-background-50 rotate-180' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-arrow-down-s-line text-sm"></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.a}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}